export var apiDocsTranslations = {
    'en-us': {
        articlesLinkText: 'Articles',
        quickstartsLinkText: 'Quickstarts',
        auth0ApisLinkText: 'Auth0 APIs',
        sdksLinkText: 'SDKs',
        readyTitleQuickstart: 'Did it work?',
        helpfulText: 'Was this helpful?',
        thanksText: 'Thanks for your feedback!',
        positiveFeedbackTitle: 'Glad to hear that! Any way we can improve?',
        negativeFeedbackTitle: 'Sorry to hear that. How can we help you?',
        sendButton: 'Submit',
        communitySection: "Can't find what you are looking for?  Check out ",
        auth0CommumityText: 'Auth0 Community',
        themeChangeTooltip: 'Change theme',
        logInButton: 'Log In',
        signUpButton: 'Sign Up',
        contactSalesButton: 'Contact sales',
        themeLight: 'Light',
        themeDark: 'Dark',
        themeSystem: 'System',
        searchPlaceholder: 'Search the docs',
        onThisPageText: 'On this Page',
    },
    'ja-jp': {
        articlesLinkText: '記事',
        quickstartsLinkText: 'クイックスタート',
        auth0ApisLinkText: 'Auth0 API',
        sdksLinkText: 'SDK',
        readyTitleQuickstart: '効果はありましたか？',
        helpfulText: 'お役に立ちましたか？',
        thanksText: 'フィードバックをありがとうございます！',
        positiveFeedbackTitle: 'よかったです！何か改善できる点はありますか？',
        negativeFeedbackTitle: 'それは残念です。何かお手伝いできることがありますか？',
        sendButton: '送信',
        communitySection: '探しているものが見つかりませんか?  チェックアウト',
        auth0CommumityText: 'Auth0 Community',
        themeChangeTooltip: 'テーマの変更 1',
        logInButton: 'ログイン',
        signUpButton: 'サインアップ',
        contactSalesButton: '営業担当に連絡',
        themeLight: 'ライト',
        themeDark: 'ダーク',
        themeSystem: 'システム',
        searchPlaceholder: 'ドキュメントを検索する',
        onThisPageText: 'このページについて',
    },
    'fr-ca': {
        articlesLinkText: 'Articles',
        quickstartsLinkText: 'Démarrage rapide',
        auth0ApisLinkText: 'API Auth0',
        sdksLinkText: 'SDK',
        readyTitleQuickstart: 'Avez-vous trouvé ce que vous cherchiez?',
        helpfulText: 'Est-ce que cela vous a été utile?',
        thanksText: 'Merci pour vos commentaires!',
        positiveFeedbackTitle: 'Super! Y a-t-il quelque chose à améliorer?',
        negativeFeedbackTitle: "Désolé d'entendre cela. Y a-t-il quelque chose que nous puissions faire pour vous aider?",
        sendButton: 'Envoyer',
        communitySection: "Vous n'avez pas trouvé ce que vous cherchiez? Consultez",
        auth0CommumityText: 'Communauté Auth0',
        themeChangeTooltip: 'Changer de thème',
        logInButton: 'Connexion',
        signUpButton: 'Inscription',
        contactSalesButton: 'Contacter le service des ventes',
        themeLight: 'Clair',
        themeDark: 'Sombre',
        themeSystem: 'Système',
        searchPlaceholder: 'Rechercher dans la documentation',
        onThisPageText: 'Sur cette page',
    },
};
